import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { loginRouteWithSlash } from '../../../../route-constants';

@Component({
  selector: 'pgh-we-know-you',
  templateUrl: './we-know-you.component.html',
  styleUrls: ['./we-know-you.component.scss']
})
export class WeKnowYouComponent implements OnInit {

  @Input() public emailAddress = '';
  @Output() changeHeading = new EventEmitter();

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.changeHeading.emit();
  }

  redirectToLogin() {
    this.router.navigate([loginRouteWithSlash]).then(() => { window.location.reload(); });
  }

  // login controls not loading to close button is handled here
  onClose() {
    this.router.navigate([loginRouteWithSlash], { queryParamsHandling: 'preserve' }).then(
      () => { window.location.reload(); });
  }
}
